/* 0番目のkey要素を表示しないチェックボックス */
import React from 'react';
import RowTemplate from '../atoms/RowTemplate';
import Messages from './Messages';
import { KeyValue } from '../types/KeyValue';
import Paragraph from './Paragraph';
interface Props {
  id: string;
  value: string;
  label: string;
  need?: boolean;
  sources: Array<KeyValue>;
  name: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  message?: string;
  help_msg?: string;
  disabled: boolean;
  looks_inactive?: boolean;
  readonly?: boolean;
}

const KeyEqualZeroDisplayHiddenCheckBox: React.FC<Props> = ({
  id,
  value,
  label,
  need,
  sources,
  name,
  message,
  help_msg,
  disabled,
  handleChange,
  looks_inactive,
  readonly,
}) => {
  /**
   * チェックボックスを表示するJSX.Elementを返却する
   * @returns JSX.Element
   */
  const returnKeyEqualZeroDisplayHiddenCheckBoxJsx = () => {
    return (
      <div id={id}>
        {sources.map((src, index) => {
          return (
            <div className={`p-checkbox-with-txt-${index}`} key={src.key}>
              <label className={`check-box-label c-check-label-${index}`}>
                <input
                  key={`${id}-${index}`}
                  disabled={disabled || readonly}
                  id={`${id}-${index}`}
                  name={name}
                  checked={src.key === value}
                  type="checkbox"
                  value={src.key}
                  onChange={handleChange}
                  className="input-checkbox"
                />
                <span className="check-icon" />
                <span className="check-txt">{src.value}</span>
              </label>
            </div>
          );
        })}
        <Messages help_msg={help_msg} valid_msg={message} />
      </div>
    );
  };

  /**
   * ラベルを表示するJSX.Elementを返却する
   * @returns JSX.Element
   */
  const returnLabelJsx = () => {
    const new_value = sources.find(src => src.key === value)?.value ?? '';

    // NOTE 確認画面で「対象外」の場合は空文字を表示する
    return <Paragraph label={new_value === '対象外' ? '' : new_value} />;
  };

  return (
    <RowTemplate
      label={label}
      need={need}
      disabled={disabled}
      looks_inactive={looks_inactive}
      content={
        <div className="p-checkbox-with">
          {disabled || looks_inactive
            ? returnLabelJsx()
            : returnKeyEqualZeroDisplayHiddenCheckBoxJsx()}
        </div>
      }
    />
  );
};

export default KeyEqualZeroDisplayHiddenCheckBox;
